// src/components/marketing/TermsPage.js
import React from "react";

const TermsPage = () => {
  return (
    <div className="container" style={{ maxWidth: 900, padding: "48px 16px" }}>
      <header style={{ textAlign: "center", marginBottom: 64 }}>
        <h1 style={{ marginBottom: 16, fontSize: "36px" }}>Terms of Use</h1>
        <p style={{ color: "var(--muted, #64748b)", fontSize: "16px" }}>
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </header>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Inertia7, you agree to be bound by these Terms
          of Use and all applicable laws and regulations. If you do not agree,
          you may not use the platform.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>2. Use of the Service</h2>
        <p>
          You are responsible for the content you publish and must ensure it
          complies with applicable laws and our community guidelines. We may
          remove content that violates these Terms without prior notice.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>3. Intellectual Property</h2>
        <p>
          The Inertia7 name, logo, and platform design are the intellectual
          property of Inertia7. You retain ownership of your content but grant
          us a non-exclusive license to host, display, and distribute it
          through our services.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>4. Disclaimers</h2>
        <p>
          The platform is provided &quot;as is&quot; without warranties of any
          kind. We do not guarantee uninterrupted service or error-free
          operation and are not liable for any damages arising from your use of
          the platform.
        </p>
      </section>

      <section style={{ marginBottom: 48 }}>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>5. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of the
          service after changes become effective constitutes your acceptance of
          the updated Terms.
        </p>
      </section>

      <section>
        <h2 style={{ 
          color: "var(--brand, #59c6c1)", 
          marginTop: 48, 
          marginBottom: 24,
          fontSize: "24px"
        }}>6. Contact</h2>
        <p>
          If you have questions about these Terms, contact us at{" "}
          <a href="mailto:support@inertia7.com">support@inertia7.com</a>.
        </p>
      </section>
    </div>
  );
};

export default TermsPage;
